export default "__VITE_ASSET__pVrUVjYp__"